import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Translate from "src/components/translate";
import Iconify from "src/components/Iconify";

const Message = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <Stack spacing={1.5} alignItems="center" textAlign="center" sx={{ mb: 3.5 }}>
      {/* Platform Title */}
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: 800,
          background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: isDark ? theme.palette.common.white : "inherit",
          fontSize: { xs: "22px", sm: "26px" },
          lineHeight: 1.3,
        }}
      >
        <Translate>register.welcome_title</Translate>
      </Typography>

      {/* Tagline Badge */}
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 0.75,
          borderRadius: "30px",
          background: isDark ? "rgba(207, 149, 42, 0.15)" : "rgba(207, 149, 42, 0.1)",
          border: `1px solid ${theme.palette.secondary.main}40`,
        }}
      >
        <Iconify icon="solar:stars-bold" sx={{ width: 18, height: 18, color: theme.palette.secondary.main }} />
        <Typography
          variant="caption"
          sx={{
            fontWeight: 700,
            fontSize: "13px",
            color: isDark ? theme.palette.secondary.light : theme.palette.secondary.dark,
          }}
        >
          <Translate>register.welcome_subtitle</Translate>
        </Typography>
      </Box>

      {/* Description */}
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          maxWidth: "440px",
          mx: "auto",
          fontSize: "14px",
          lineHeight: 1.5,
          pt: 0.5,
        }}
      >
        <Translate>register.welcome_desc</Translate>
      </Typography>
    </Stack>
  );
};

export default Message;
